import { hopplerApi } from '../../constants/api';
import Axios from 'axios';
import { ListResponse, Listing, User, StatusResponse } from '../../types';
import { Comment } from '../../types/comment.model';


class CommentService {

  // type: listing or inquiry
  public getComments(key: string, type: string) {
    let path: string = `${hopplerApi.host}/kumita/comment/${type}/${key}`;

    return Axios.get<ListResponse<Comment>>(path, {
      withCredentials: true
    });
  }

  public addComment(propertyKey: string, comment: string, type: string) {
    let path: string = `${hopplerApi.host}/kumita/comment/${type}/${propertyKey}`;
    return Axios.post<ListResponse<StatusResponse>>(path, { comment } ,{
      withCredentials: true
    });
  }
  
  public editComment(propertyKey: string, comment: string, commentId: any) {
    let path: string = `${hopplerApi.host}/kumita/comment/listing/${propertyKey}/${commentId}`;
    return Axios.put<ListResponse<StatusResponse>>(path, { comment } ,{
      withCredentials: true
    });
  }

  public deleteComment(propertyKey: string, commentId: any) {
    let path: string = `${hopplerApi.host}/kumita/comment/listing/${propertyKey}/${commentId}`;
    return Axios.delete<ListResponse<StatusResponse>>(path, {
      withCredentials: true
    });
  }
}

export default new CommentService();
